import React, { useState, useEffect } from 'react';
import AppNavbar from '../../components/AppNavbar/AppNavbar';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Footer from '../../components/Footer/Footer';
import mainStyles from '../Pages.module.css';
import styles from './LandingPage.module.css';

import Toast from 'react-bootstrap/Toast';
import { useLocation } from 'react-router-dom';

import sampleSs from '../../img/sample_ss.png'
import loadProject from '../../img/load-project.png'
import inspectProject from '../../img/inspect-project.png'
import createCuttingPlan from '../../img/create-cutting-plan.png'
import inspectCuttingPlan from '../../img/inspect-cutting-plan.png'

// import { loginUser } from '../services/authService';

import { useTranslation } from "react-i18next";

const LandingPage = () => {

    const [showToast, setShowToast] = useState(false);
    const location = useLocation();

    document.title = "Tasnifer"
    
    const { i18n, t } = useTranslation();

    const docsLink = `https://resources.tasnifer.com${i18n.language === "tr" ? "" : `/${i18n.language}`}/docs`;

    useEffect(() => {
        const searchParams = new URLSearchParams(location.search);
        if (searchParams.get('logout')) {
            setShowToast(true);
        }
    }, [location.search]);


    return (
        <div className={mainStyles.flexWrapper}>
            <AppNavbar />
            <div className={mainStyles.content}>
                <div className={styles.heroSection}>
                    <Container>
                        <Row className="align-items-center">
                            <Col md={6} className="text-center text-md-start">
                                <h1 className={styles.heroTitle}>
                                    {t("Kesim Optimizasyonu")}
                                </h1>
                                <p className={styles.heroSubtitle}>
                                    {t("İnşaat donatıları ve çelik profiller için en az fire ile en optimum kesim planını yapıyoruz.")}
                                </p>
                                <button 
                                    className={styles.ctaButton}
                                    onClick={() => {
                                        window.location.href = `/${i18n.language}/projects`;
                                    }}
                                >
                                    {t("Hemen Başlayın")}
                                </button>
                            </Col>
                            <Col md={6} className="text-center">
                                <img src={sampleSs} className={styles.heroImage} alt="Sample Screenshot" />
                            </Col>
                        </Row>
                    </Container>
                </div>

                <div className={styles.videoSection}>
                    <Container>
                        <Row className="text-center">
                            <h2 className={styles.videoSectionHeader}>{t("Tasnifer Nedir?")}</h2>
                            <p className={styles.videoSectionDescription}>
                                <span className="fw-bold">Tasnifer</span> {t("Tasnifer tanım 1")}
                            </p>
                        </Row>
                        <Row className="justify-content-center">
                            <Col md={10} className="d-flex justify-content-center">
                                <div className={`ratio ratio-16x9 ${styles.videoWrapper}`}>
                                    <iframe
                                        src="https://www.youtube.com/embed/1qex_LTYak8?si=A4OuwmZXy9shFvKF"
                                        title="Tasnifer"
                                        allowFullScreen
                                    ></iframe>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </div>

                <div className={styles.howItWorks}>
                    <Container>
                        <Row className="text-center">
                            <h2 className={styles.howItWorksHeader}>{t("Nasıl Çalışır?")}</h2>
                            <p className={styles.howItWorksDescription}>
                                {t("Tasnifer ile kesim planı oluşturmanın adımlarını keşfedin.")}
                            </p>
                        </Row>
                        <Row className={styles.howItWorksStep}>
                            <Col md={5} className="text-center">
                                <img src={loadProject} className={styles.stepImage} alt="Step 1" />
                            </Col>
                            <Col md={7} className={styles.stepContent}>
                                <h4 className={styles.stepHeader}>{t("1. Adım")}</h4>
                                <p className={styles.stepDescription}>{t("1. Adım Açıklama")}</p>
                            </Col>
                        </Row>
                        <Row className={styles.howItWorksStep}>
                            <Col md={5} className="text-center">
                                <img src={inspectProject} className={styles.stepImage} alt="Step 2" />
                            </Col>
                            <Col md={7} className={styles.stepContent}>
                                <h4 className={styles.stepHeader}>{t("2. Adım")}</h4>
                                <p className={styles.stepDescription}>{t("2. Adım Açıklama")}</p>
                            </Col>
                        </Row>
                        <Row className={styles.howItWorksStep}>
                            <Col md={5} className="text-center">
                                <img src={createCuttingPlan} className={styles.stepImage} alt="Step 3" />
                            </Col>
                            <Col md={7} className={styles.stepContent}>
                                <h4 className={styles.stepHeader}>{t("3. Adım")}</h4>
                                <p className={styles.stepDescription}>{t("3. Adım Açıklama")}</p>
                            </Col>
                        </Row>
                        <Row className={styles.howItWorksStep}>
                            <Col md={5} className="text-center">
                                <img src={inspectCuttingPlan} className={styles.stepImage} alt="Step 4" />
                            </Col>
                            <Col md={7} className={styles.stepContent}>
                                <h4 className={styles.stepHeader}>{t("4. Adım")}</h4>
                                <p className={styles.stepDescription}>{t("4. Adım Açıklama")}</p>
                            </Col>
                        </Row>
                    </Container>
                    <Container fluid className="text-center mt-4">
                        <p className={styles.additionalInfo}>
                            {t("detaylı bilgi için 1")} <a href={docsLink} className={styles.userManualLink}>{t("Kullanım Rehberi")}</a> {t("detaylı bilgi için 2")}
                        </p>
                    </Container>
                </div>

            </div>
            <Footer />
            <Toast
                onClose={() => setShowToast(false)}
                show={showToast}
                bg="success"
                delay={3000}
                autohide
                style={{
                    position: 'fixed',
                    bottom: 20,
                    left: 20,
                    zIndex: 9999,
                }}
            >
                <Toast.Header>
                    <strong className="me-auto">{t("Bilgi")}</strong>
                </Toast.Header>
                <Toast.Body style={{ color: 'white' }}>{t("Çıkış yapıldı.")}</Toast.Body>
            </Toast>

        </div>


    );
};

export default LandingPage;